<template>
  <div class="deal-flow">
    <!-- <button type="button" @click='test' name="button">test</button> -->
    <div class="deal-title clearfix">
      <!-- <h2 class="fl">2016年12月<i><img src="../../images/personal_center/icon-calendar.png" alt="" /></i></h2> -->
      <div class="input-group date deal-date fl" data-link-field="dtp_input2">
        <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span>
        <input class="form-control date-input" ref="date" disabled size="16" type="text">
      </div>
      <p class="fr">
        <span class="spending"><i><img src="../../images/personal_center/deal-flow4.png"/></i>支出</span>
        <!-- <span class="money"><strong>{{tradeBalance.rmb_out}}</strong> 现金</span> -->
        <span><strong>{{tradeBalance.bkb_out}}</strong> 鲸币</span>
        <span class="income"><i><img src="../../images/personal_center/deal-flow3.png"/></i>收入</span>
        <!-- <span class="money"><strong>{{tradeBalance.rmb_in}}</strong> 现金</span> -->
        <span><strong>{{tradeBalance.bkb_in}}</strong> 鲸币</span>
      </p>
    </div>
    <div class="deal-header clearfix">
      <div class="screening clearfix">
          <input type="radio" name="screening" value="" v-model="billType" id="screening1">
          <label class="form-checked-state f14" for="screening1">全部</label>
          <input type="radio" name="screening" value="1" v-model="billType" id="screening2">
          <label class="form-checked-state f14" for="screening2">支出</label>
          <input type="radio" name="screening" value="0" v-model="billType" id="screening3">
          <label class="form-checked-state f14" for="screening3">收入</label>
          <!-- <input type="radio" name="screening" value="2" v-model="billType" id="screening4">
          <label class="form-checked-state f14" for="screening4">提现</label>
          <input type="radio" name="screening" value="3" v-model="billType" id="screening5">
          <label class="form-checked-state f14" for="screening5">充值</label> -->
      </div>
      <div class="fr clearfix page-info">
        <p class="fl"><span>{{page.curPage}}</span>/{{page.totalPage}}</p>
        <div class="fr page clearfix">
          <a href="javascript:;" @click="getTradeHistory(date, billType, page.curPage-1)" class="left" :class="{'disable':page.curPage<=1}"><img src="../../images/personal_center/collection-left.png" alt="" /></a>
          <a href="javascript:;" @click="getTradeHistory(date, billType, page.curPage+1)" class="right" :class="{'disable':page.curPage==page.totalPage}"><img src="../../images/personal_center/collection-right.png" alt="" /></a>
        </div>
      </div>
    </div>
    <ul v-if="tradeList.length&&!isLoading" class="deal-list">
      <li v-for="(item,index) in tradeList" :key="index">
        <img class="trade-icon" v-if="item.trade_type === 3" src="../../images/personal_center/icon-bkb.png" />
        <img class="trade-icon" v-else-if="item.trade_type === 1" src="../../images/personal_center/icon-gift.png" />
        <img class="trade-icon" v-else-if="[0, 2, 5].includes(item.trade_type)" src="../../images/personal_center/icon-taskprice.png" />
        <img class="trade-icon" v-else-if="item.trade_type === 4" src="../../images/personal_center/icon-add-coin.png" />
        <img class="trade-icon" v-else-if="item.trade_type === 1000" src="../../images/personal_center/icon-buy-goods.png" />
        <div class="deal-text">
          <h4>
            <span>{{ item.name || item.product }}</span>
            <p :class="['add', { 'reduce': item.inout }]">
              <strong>{{ (item.inout ? '-' : '+') + item.amount }}</strong>
              <span>{{ item.coin_type === 'common' ? '普通鲸币' : item.coin_type === 'share' ? '分享鲸币' : '专业鲸币' }}</span>
            </p>
          </h4>
          <div class="deal-info">
            <span class="date-time">{{item.time}}</span>
            <div class="arrow-wrapper" :class="{ 'more': item.show }" @click="fold(index)">
              <span class="deal-details">
                {{ item.show ? '收起' : '展开' }}详情
              </span>
              <i></i>
            </div>
          </div>
          <transition name="slide">
            <div class="text-wrapper" v-show="item.show">
              <p>商品名称： {{ item.product }}</p>
              <p>当前状态： {{ item.get_status_display  }}</p>
              <p v-for="(note, index) in item.notes" :key="index">{{ note }}</p>
              <p>交易单号： {{ item.no }}</p>
              <p>交易备注：{{ item.remark }}</p>
            </div>
          </transition>
        </div>
      </li>
    </ul>
    <loading :ifLoadingStart="isLoading" style="padding: 100px 0;"></loading>
    <!-- <div v-if="isLoading" class="isLoading">
       <img alt="loadding" src="../../images/common/loading_2_24x24.gif"> 数据加载中,请稍候...
    </div> -->
    <div v-show="!tradeList.length&&!isLoading" class="content-none">
      <!-- <v-page :page="page" class="pages"></v-page> -->
      <img src="../../images/personal_center/work-null.png" alt="" />
      <p v-if="billType===''">本月未产生任何交易</p>
      <p v-if="billType==='1'">本月查无任何支出记录</p>
      <p v-if="billType==='0'">本月查无任何收入记录</p>
      <p v-if="billType==='2'">本月查无任何提现记录</p>
      <p v-if="billType==='3'">本月查无任何充值记录</p>
    </div>
    <v-page v-if="tradeList.length&&!isLoading" :page="page" class="pages"></v-page>
  </div>
</template>
<script type="text/javascript">
  import vPage from "../page.vue";
  import loading from "../loading.vue";
  export default {
    data() {
      return {
        isLoading: false,
        tradeBalance: {
          rmb_in: 0, //收入人民币
          bkb_out: 0, //支出人民币
          bkb_in: 0, //收入鲸币
          rmb_out: 0 //支出鲸币
        },
        date: "",  // 日期
        billType: "", //(0, u'收入'),(1, u'支出'),(2, u'提现'),3 充值 (可选，不提供则为全部)
        tradeList: [  // 交易列表
          {
            receipt: "", //交易单据
            trade_type: 0,   // 鲸币交易类型 0任务奖励  1礼品码 2其他
            remark: "",     // 交易备注
            inout: 0, // 0收入，1支出
            amount: "", //交易总额
            money_type: 0, //币种 1鲸币，2人民币
            time: "", //交易时间
            name: '', // 交易标题
            get_status_display: "", //交易状态
          }
        ],
        page: {  // 页码相关
          total: 0,
          curPage: 1,
          totalPage: 1
        }
      }
    },
    watch: {
      "page.curPage": {
        handler: function(newVal, oldVal){
          this.getTradeHistory(this.date, this.billType, newVal);
        }
      },
      billType: {
        handler: function(newVal, oldVal){
          this.getTradeHistory(this.date, newVal, 1);  // 默认第一页
        }
      }
    },
    methods: {
      fold(index) {
        this.tradeList[index].show = !this.tradeList[index].show;
        this.tradeList.splice();
      },
      initAnimate() {
        const $datepicker = $('.date').datetimepicker({
          language:  'zh-TW',
          weekStart: 1,
          todayBtn:  true,
          autoclose: true,
          todayHighlight: true,
          startView: 3,
          minView: 2,
          forceParse: false,
          format:"yyyy年mm月",
          minView: 3,
        }).on("changeDate",(res) => {
          // 如果是点击"今天"按钮触发的，跳过这里的处理（在 todayBtn 点击事件中单独处理）
          if (this._isTodayBtnClick) {
            this._isTodayBtnClick = false;
            return;
          }
          this.date = this.$refs.date.value;
          this.getTradeHistory(this.$refs.date.value,this.billType,1);
          this.getTradeBalance();
        });

        // 监听"今天"按钮的点击事件
        $(document).on('click', '.datetimepicker .today', () => {
          this._isTodayBtnClick = true;
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const todayDate = `${year}-${month}-${day}`;

          // 设置显示值为年月格式（保持 UI 一致）
          this.$refs.date.value = `${year}年${month}月`;
          // 使用完整日期格式进行查询
          this.date = todayDate;
          this.getTradeHistory(todayDate, this.billType, 1);
          this.getTradeBalance();

          // 关闭日期选择器
          $datepicker.datetimepicker('hide');
        });
      },
      /* 获取交易记录
        date 日期 '2017-06'  空则为当月
        type 类型  0 收入 1 支出 2 提现  空则为全部
        page 页码
      */
      getTradeHistory(date, type, page) {
        if (page<1||page>this.page.totalPage) {
          return ;
        }
        let formData = {};
        if (date) {
          formData.create_time = date.replace("年","-").replace("月","");
        }
        if (type!="") {
          formData.bill_type = type;
        }
        formData.page = page;
        this.isLoading = true;
        axios.get(myUrl + "trade/bill/", { params: formData }).then((res) => {
          if(!this.date){
            let curDate = res.headers.date;
            if (curDate) {
              var date = new Date(curDate);
            }else {
              var date = new Date();
            }
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            date = year + "年" + (month<10?"0"+month:month) + "月";
            this.$refs.date.value = date;
            this.date = date;
          }
          res = res.data;
          if (res.result) {
            const { count, results } = res.data
            this.tradeList = results
            this.page.totalPage = Math.ceil(count / 10) || 1
            this.tradeList.forEach((data) => {
              data.show = false
              Object.assign(data, data.receipt)
              data.amount = data.amount.split('.')[0]
            })
            this.getTradeBalance();
          }else {
            console.log(res.message);
          }
          this.isLoading = false;
        })
      },
      getTradeBalance() {
        let formData = {};
        formData.time_range = this.date.replace("年","-").replace("月","");
        axios.post(myUrl + "trade/balance/",qs.stringify(formData)).then((res) => {
          res = res.data;
          if (res.result) {
            this.tradeBalance = res.data;
          }else {
            console.log(res.message);
          }
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        const year = new Date().getFullYear()
        const month = new Date().getMonth() + 1
        const date = `${year}年${month}月`
        this.getTradeHistory(date, "", 1);  //
        this.initAnimate();
      })
    },
    components: {
      "v-page": vPage,
      loading
    }
  }
</script>

<style media="screen" lang="scss">
.slide-enter-active {
  animation: slide-in .3s ease;
}
.slide-leave-active {
  animation: slide-out .3s ease;
}
@keyframes slide-in {
  0% {
    height:0;
    padding-top:0;
    padding-bottom:0;
    margin-top:0;
  }
  100% {
    height:auto;
    /*height:130px;*/
    padding-top:17px;
    padding-bottom:17px;
    margin-top:20px;
  }
}
@keyframes slide-out {
  0% {
    /*height:130px;*/
    height: auto;
    padding-top:17px;
    padding-bottom:17px;
    margin-top:20px;
  }
  100% {
    height:0;
    padding-top:0;
    padding-bottom:0;
    margin-top:0px;
  }
}
.deal-flow{
  background: #fff;
  padding: 10px 45px 28px;
  min-height: 779px;
  .slide-enter-active {
    animation: slide-in .5s;
  }
  .deal-title{
    padding: 12px 0;
    border-bottom: 1px solid #f4f4f4;
    .deal-date{
      .form-control{
        border: none;
        font-size: 18px;
        font-weight: bold;
        color: #77787f;
        width: 160px;
        box-shadow:none;
      }
      .input-group-addon{
          border: none;
          padding: 9px 8px;
          background: none;
          width: 35px;
          height: 100%;
          position: absolute;
          right: 0;
          z-index: 10;
      }
      .data-input{
        padding:0;
      }
    }
    p{
      margin-top: 6px;
      font-size: 12px;
      font-weight: normal;
      line-height: 25px;
      color: #aaa;
      img{
        display: inline-block;
        vertical-align: -1px;
        margin-right: 5px;
      }
      strong{
        font-size: 14px;
        color: #77787f;
      }
      .spending{
        color: #ff6600;
        margin-right: 5px;
        &>i{
          display: inline-block;
          vertical-align: -2px
        }
      }
      .income{
        margin-right: 5px;
        color: #75ce3a;
        margin-left: 16px;
        padding-left: 16px;
        border-left: 1px solid #f4f4f4;
        &>i{
          display: inline-block;
          vertical-align: -2px
        }
      }
      .money{
        margin-right: 13px;
      }
    }
  }
  .deal-header{
    padding: 19px 0 12px 0;
    .screening{
      float: left;
      background: #fff;
      label{
        float:left;
        display: block;
        width: 53px;
        height: 26px;
        border: 1px solid #ddd;
        margin-left: -1px;
        line-height: 24px;
        text-align: center;
        font-size: 12px;
        color: #a6a6a6;
      }
      label:first-of-type{
        border-radius: 3px 0 0 3px;
      }
      label:last-of-type{
        border-radius: 0 3px 3px 0;
      }
      input{
        display: none;
      }
      input:checked + label{
        background: #57a3f1;
        color: #fff;
        border-color: #57a3f1;
      }
    }
    .page-info{
      p{
        line-height: 26px;
      }
      .page{
        margin-left: 20px;
       a{
        display: block;
        float: left;
        width: 53px;
        height: 26px;
        border: 1px solid #ddd;
        margin-left: -1px;
        line-height: 22px;
        text-align: center;
        background: #fff;
       }
       a.disable{
        background: #f1f1f1;
       }
       a.left{
        border-radius: 3px 0 0 3px;
       }
       a.right{
        border-radius: 0 3px 3px 0;
       }
      }
    }
  }
  .isLoading{
    text-align: center;
    margin-top: 100px;
    margin-bottom: 100px;
  }
  .deal-list{
    li{
      display: flex;
      align-items: flex-start;
      padding: 25px 0;
      border-bottom: 1px solid #f4f4f4;
      .trade-icon {
        height: 62px;
        width: 62px;
      }
      .deal-text{
        margin-left: 24px;
        width:1002px;
        h4{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 8px;
          font-size: 16px;
          color: #444444;
          .add {
            display: flex;
            align-items: center;
            font-weight: bold;
            margin-right: 8px;
            color: #aaa;
            font-size: 12px;
            strong{
              font-size:18px;
              color: #75ce3a;
              margin-right: 5px;
            }
            &.reduce {
              strong {
                color: #ff6600;
              }
            }
          }
        }
        .deal-info{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 13px;
          .date-time{
            color: #888888;
            font-size: 14px;
          }
        }
        .text-wrapper{
          margin-top: 20px;
          width: 920px;
          background: #fafafa;
          border-radius: 3px;
          padding: 17px 24px;
          font-size: 12px;
          overflow: hidden;
          color: #888;
          transform-origin: 0px 0px 0px;
          >p{
            line-height: 23px;
          }
        }
      }
      .deal-details{
        color: #57a3f1;
        font-size: 14px;
      }
      .arrow-wrapper{
        float: right;
        cursor: pointer;
        user-select: none;
        -webkit-user-select: none;
        -o-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        i{
          display: inline-block;
          vertical-align: middle;
          margin-left: 5px;
          width: 9px;
          height: 6px;
          background: url(../../images/personal_center/deal-flow.png)no-repeat center center;
          -webkit-transition: -webkit-transform 0.2s ease-out;
          -moz-transition: -moz-transform 0.2s ease-out;
          -o-transition: -o-transform 0.2s ease-out;
          -ms-transition: -ms-transform 0.2s ease-out;
        }
        &.more{
          i{
            -webkit-transform: rotateZ(180deg);
            -moz-transform: rotateZ(180deg);
            -o-transform: rotateZ(180deg);
            -ms-transform: rotateZ(180deg);
            transform: rotateZ(180deg);
          }
        }
      }
    }
  }
  .pages{
    text-align: right;
    /*color: #878996;*/
    margin-top: 28px;
  }
  .form-control[disabled]{
    cursor: default;
    background-color: transparent;
  }
}

</style>



// WEBPACK FOOTER //
// deal_flow.vue?aecf52ba